import {
  Table,
  TableCell,
  TableBody,
  TableHead,
  TableRow,
  Button,
} from "@aws-amplify/ui-react";

export default function CareGiverViewTable({
  careGiversData = [],
  onRevokeAccessClick,
  onGiveAccessClick,
}) {
  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableCell as="th">Actions</TableCell>
          <TableCell as="th">Given Name</TableCell>
          <TableCell as="th">Username</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {careGiversData?.map((caregiver) => {
          return (
            <TableRow key={`cg_${caregiver.caregiverUserId}`}>
              <TableCell>
                {caregiver?.isActive === 1 ? (
                  <Button size="small" variation="destructive" onClick={onRevokeAccessClick.bind(this, caregiver.caregiverUserId)}>
                    REMOVE ACCESS
                  </Button>
                ) : (
                  <Button size="small" variation="primary" onClick={onGiveAccessClick.bind(this, caregiver.caregiverUserId)}>
                    GIVE ACCESS
                  </Button>
                )}
              </TableCell>
              <TableCell>{caregiver?.givenName}</TableCell>
              <TableCell>{caregiver?.username}</TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
}
